import {
  Card,
  LinearProgress,
  Typography
} from '@material-ui/core';

const LoadingList = () => (
  <Card style={{
    padding: '10px',
    textAlign: 'center',
    fontSize: '20px',
    fontWeight: 'bold'
  }}
  >
    <p style={{ padding: '10px' }}>
      <Typography variant="h3" component="h2">
        Carregando
      </Typography>
    </p>
    <LinearProgress />
  </Card>
);

export default LoadingList;
